<template>
    <div class="description--element">
        <div :class="{'caption': !leading, 'subtitle-1': leading}">
            <template v-if="link">
                <a :href="link" v-if="link">{{ captionText }} <svg-vue :icon="icon" class="icon" v-if="icon" /></a>
            </template>
            <template v-else>
                {{ captionText }}
                <svg-vue :icon="icon" class="icon" v-if="icon" />
            </template>
        </div>
        <div :class="{'subtitle-2': !leading, 'body-2': leading}"><translate>{{ title }}</translate></div>

    </div>
</template>

<script>
export default {
    name: 'DescriptionElement',
    props: [
        'caption',
        'title',
        'isDate',
        'isCurrency',
        'isPercentage',
        'link',
        'leading',
        'icon',
    ],
    computed: {
        captionText() {
            if (this.isDate)
                return this.caption ? this.$date(this.caption) : '-';
            else if (this.isCurrency)
                return this.caption ? this.$currency(this.caption) : '-';
            else if (this.isPercentage)
                return this.caption ? parseFloat(this.caption).toFixed(2).replace('.', ',') + '%' : '-';
            else
                return this.caption ? this.caption : '-';
        },
    }
};
</script>
